import {types} from './types';

const initialState = {
    history: {
        list: [],
        page: 0
    },
    list: [],
    groups: {
        list: [],
        summ: 0
    },
    live: []
}

export function mobileCreditReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST_CREDIT_HISTORY:
            return { ...state, history: action.payload};
        case types.SET_LIST_CREDIT:
            return { ...state, list: action.payload};
        case types.SET_LIST_GROUPS:
            return { ...state, groups: action.payload}
        case types.SET_CREDIT_LIVE:
            return { ...state, live: action.payload}
        default:
            return state
    }
}